import { common } from '@tencent/ceiba-base-components';
import Vue from 'vue';

let loginManagerInstance = null;

const isApp =  () => !!window.navigator.userAgent.match(/tgclub/i);


const checkAccountType = () => (common.tool.getCookie('acctype')  === 'wx' ? 'wx'  : 'qq');

function loginByQQ(loginManager) {
  loginManager.login({
    iUseQQConnect: 0, // 是否使用QQ互联
    oQQConnectParams: {
      appId: '101478665',
      redirect_uri: 'http://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
    },
  });
  localStorage.curPlatform = 'qq';
}
function loginByWx(loginManager) {
  loginManager.loginByWX({
    appConfig: {
      QQBrowserAppId: '106', // 在QQ浏览器端申请的APPID，保持不变
      WxAppId: 'wx5a3bbeac0d87c75a', // 需要在微信申请openLink权限，
      AppName: '心悦俱乐部', // 业务的中文名称
      scope: 'snsapi_userinfo', // 默认是 snsapi_base 静默授权，如果游戏无静默权限，就需要手动改成 snsapi_userinfo
      LogoUrl: 'http://ossweb-img.qq.com/images/feiji/web201507/logo.png', // 业务在授权时需要显示的正方形标准Logo，
    },
    userinfoSpan: 'userinfo',
  });
  localStorage.curPlatform = 'wx';
}

export default {

  /**
   * 心悦登录特点
   * 游戏：只有手游，没有端游
   * 注销：APP里没有登出操作
   * 自动登录:QQ浏览器pt登录，微信则wx登录
   * 心悦APP内QQ默认用QC互联登录
   */
  initLogin: async () => new Promise((resolve) => {
    console.log('tgclub initLogin begin');
    window.iUseQQConnect = common.tool.getCookie('acctype') === 'qc' ? 1 : 0;
    window.need('biz.login', (LoginManager) => {
      LoginManager.init({
        appConfig: {
          gameDomain: 'xinyue.qq.com',
          WxAppId: 'wx5a3bbeac0d87c75a',
          scope: 'snsapi_userinfo',
        },
        oQQConnectParams: {
          appId: '101478665',
          redirect_uri: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
        },
        iUseQQConnect: window.iUseQQConnect,
      });
      loginManagerInstance = LoginManager;
      console.log('tgclub initLogin done instance=', loginManagerInstance);
      resolve();
    });
  }),
  /**
   * 去登录操作
   * @param {登录方式} loginType
   */
  login: async (params = { loginType: 'qq' }) =>  {
    console.log('tgclub login');
    if (params.loginType === 'qq') loginByQQ(loginManagerInstance);
    if (params.loginType === 'wx') loginByWx(loginManagerInstance);
  },
  /**
   * 检查登录信息，返回是否登录+登录信息
   * @returns {
   *  "isLogin":true,
   *  "userInfo":{}
   * }
   */
  checkLogin: async () => await new Promise((resolve) => {
    console.log('loginManagerInstance', loginManagerInstance);
    loginManagerInstance.checkLogin((userInfo) => {
      console.log('checklogin loginRes= 1.0.6', userInfo);
      // 采用localStorage 保持登录的连续性 保持活动页面上一次保持登录的方式
      //
      let { curPlatform } = localStorage;
      console.log('checklogin loginRes= 1.0.6 curPlatform from localStorage ', curPlatform);

      if (!curPlatform) {
        curPlatform = Vue.prototype.$platform.isWX  ? 'wx' : 'qq';
      }
      if (isApp()) {
        curPlatform  = checkAccountType();
      }
      console.log('checklogin loginRes= 1.0.6 curPlatform ', curPlatform);

      if (curPlatform === 'wx') {
        const getUserInfoParam = {
          openid: common.tool.getCookie('openid'),
          access_token: common.tool.getCookie('access_token'),
          lang: 'zh_CN',
        };
        console.log('getUserInfoByWxOpenId=', getUserInfoParam);
        loginManagerInstance.getUserInfoByWxOpenId(getUserInfoParam, (wxUserInfo) => {
          console.log('登录成功，wx用户信息为', wxUserInfo);
          // eslint-disable-next-line no-param-reassign
          userInfo.avatar =  wxUserInfo.headimgurl ? `${wxUserInfo.headimgurl}/64` : '';
          // eslint-disable-next-line no-param-reassign
          userInfo.nickName = wxUserInfo.nickname;
          resolve({
            isLogin: true,
            userInfo,
          });
        }, (err) => {
          console.log('获取用户信息失败', err);
        });
      } else {
        let uin = common.tool.getCookie('uin') || '';
        uin = uin.substr(1);
        if (uin.indexOf('0') === 0)   {
          uin = uin.substr(1);
        }
        // QQ号不显示 昵称 因为有会有表情文字其是乱码
        // eslint-disable-next-line no-param-reassign
        userInfo.nickName = uin || userInfo.nickname;
        loginManagerInstance.getUserFace((sAvatar) => {
          console.log(' get QQ getUserFace sAvatar ', sAvatar);
          // eslint-disable-next-line no-param-reassign
          userInfo.avatar =  typeof sAvatar === 'string' ? sAvatar : sAvatar.userFace ;
          console.log(' get QQ Userinfo ', userInfo);
          resolve({
            isLogin: true,
            userInfo,
          });
        });
      }
    }, (error) => {
      console.log('version 1.0.6 checklogin fail=', error);
      let  { isQQ, isWX } = Vue.prototype.$platform;
      if (isApp()) {
        isQQ  = checkAccountType() === 'qq';
        isWX  = checkAccountType() === 'wx';
      }
      console.log('.isWX = ', isWX);
      console.log('.isQQ = ', isQQ);
      const { game_type = 0 } = Vue.prototype.$actInfo || {};
      //  微信在端游的时候不拉去分享
      // eslint-disable-next-line camelcase
      console.log('game_type from state= ', game_type);
      console.log('Vue.prototype.$actInfo ', Vue.prototype.$actInfo);
      // 默认端游不进行微信登录
      isQQ &&  loginByQQ(loginManagerInstance);
      // eslint-disable-next-line camelcase
      isWX && game_type !== 1 &&  loginByWx(loginManagerInstance);
      console.log('game_type =', game_type, 'game_type === 1 是端游 默认端游不进行微信登录');
      resolve({
        isLogin: false,
        userInfo: {},
      });
    });
  }),
  /**
   * 登出操作
   */
  logout: async () => {
    await loginManagerInstance.logout({});
    localStorage.curPlatform = '';
  },

};
